<style lang="less">
.van-checkbox--checked {
  color: #fff;
  border-color: #ff9000 !important;
  background-color: #ff9000 !important;
}
.favorite {
  .van-checkbox__label {
    width: 80%;
    margin-left: 20px;

    .van-card__footer {
      width: 90%;
      height: 100%;
      & > div {
        width: 100%;
        height: 100%;

        //点击触发事件的按钮
        & > div {
          width: 100%;
          height: 100%;
          z-index: 99999;
        }
      }
    }
  }
  .cart-empty {
    text-align: center;
    .cart-tip {
      padding: 0 0.3rem;
      height: 0.8rem;
      line-height: 0.8rem;
      background: rgb(253, 251, 238);

      span {
        display: block;
        float: left;

        &:nth-child(1) {
          width: 0.3rem;
          height: 0.8rem;
          margin-right: 0.1rem;
          background: url("../../../static/image/myOrder/ios/favorites.png")
            no-repeat center center;
        }
        &:nth-child(2) {
          color: rgb(255, 144, 0);
          font-size: 0.22rem;
        }
        &:nth-child(3) {
          float: right;
          width: 0.3rem;
          height: 0.8rem;
          background: url("../../../static/image/goods/splitPic/addCart/ios/back.png")
            no-repeat center center;
        }
      }
    }

    .cart-ico {
      padding: 0.42rem 2.62rem 0.6rem;
      .cart-icon-p {
        display: block;
        width: 2.28rem;
        height: 2.28rem;
        background: url("../../../static/image/goods/splitPic/addCart/ios/cart.png")
          no-repeat center center;
      }
    }
    .empty-warm {
      font-size: 0.3rem;
      margin-top: 0.3rem;
      margin-bottom: 0.02rem;
      color: rgb(51, 51, 51);
    }
    .pick-some {
      font-size: 0.24rem;
      color: rgb(123, 123, 123);
      margin-bottom: 0.74rem;
    }
    .van-button--small {
      font-size: 0.34rem;
      color: #fff;
      background-color: rgb(255, 144, 0);
      width: 4.56rem;
      height: 0.8rem;
      line-height: 0.8rem;
      border-radius: 0.2rem;
    }
  }

  .cart-section {
    .goods-count {
      padding: 0.24rem 0.24rem 0.16rem;
      color: rgb(102, 102, 102);
      font-size: 0.24rem;
    }
    .van-checkbox-group {
      padding: 0 0.24rem;

      .van-checkbox {
        border-bottom: 1px solid #e5e5e5;
      }
    }

    .van-submit-bar {
      .van-submit-bar__bar {
        height: 0.88rem;
        line-height: 0.88rem;

        & > :nth-child(1) {
          padding-left: 0.24rem;

          .van-checkbox__label {
            font-size: 0.28rem;
            color: #000;
          }
        }
        .van-submit-bar__price {
          visibility: hidden;
        }
        & > button {
          width: 1.62rem;
          .van-button--danger {
            background-color: rgba(222, 10, 42, 0.96);
            border: 1px solid rgba(222, 10, 42, 0.96);
          }
        }
      }
    }
  }
}

//重置vant-card
.van-card {
  padding: 0.32rem 0;
  //重要的
  height: auto;
  padding: 5px 10px !important;

  .van-card__thumb {
    position: relative;
    top: 0;
    left: 0;
    width: 1.68rem;
    height: 1.68rem;
    margin-right: 0.2rem;
    // background: url("../../../static/image/goods/切图/填写订单/ios/Photo.png")
    //   no-repeat center center;
    & > img {
      //  display: none;
    }
  }
  .van-card__content {
    position: relative;
    .van-card__row {
      margin-bottom: 0.16rem;

      .van-card__title {
        font-size: 0.26rem;
        color: rgb(51, 51, 51);
      }
      .van-card__price {
        font-size: 0.32rem;
        color: rgb(255, 144, 0);
        position: absolute;
        left: 0;
        top: 1.3rem;
        text-align: left;
      }
      .van-card__desc {
        font-size: 0.22rem;
        color: rgb(153, 15);
      }
    }
  }
}
</style>


<template>
  <div class='favorite'>
    <!-- <van-nav-bar title="我的收藏夹"
                 left-arrow
                 @click-left="onClickLeft"
                 @click-right='edit' /> -->

    <div class="cart-section"
         v-if="goods!=0">
      <div class='goods-count'>
        共{{goods.length}}件商品
      </div>
      <van-checkbox-group v-model="checkedGoods">
        <van-checkbox v-for="item in goods"
                      v-if='isEdit == 0'
                      :key="item.id"
                      :name="item.id">
          <van-card :title="item.name"
                    :desc="item.kindName"
                    :price="parseInt(item.price)"
                    :thumb="item.goodsDetail.src">
            <div slot="footer">
              <div class='hhh'
                   @click="toProductDetail(item.id)">
              </div>
            </div>
          </van-card>
        </van-checkbox>
      </van-checkbox-group>
      <van-submit-bar :price="totalPrice"
                      :disabled="!goods.length"
                      button-text="删除"
                      @submit="onDelete">
        <div @click="checkall">
          <van-checkbox v-model="allChecked">全选</van-checkbox>
        </div>
      </van-submit-bar>
    </div>
    <div class="cart-empty"
         v-else>
      <div class="cart-ico">
        <i class="cart-icon-p"></i>
      </div>
      <p class="empty-warm">连一个喜欢的商品都没有吗？</p>
      <p class='pick-some'>去挑选几件喜欢的商品吧</p>
      <router-link to="/home">
        <van-button size="small">随便逛逛</van-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import store from '@/vuex/store'
import { mapState } from 'vuex'
//import {eventBus} from '../../assets/js/eventBus'

//import { Checkbox, CheckboxGroup, Card, SubmitBar } from 'vant';
export default {
  //components: {
  //  [Card.name]: Card,
  //  [Checkbox.name]: Checkbox,
  //  [SubmitBar.name]: SubmitBar,
  //  [CheckboxGroup.name]: CheckboxGroup
  //},
  name: 'bookmark',
  store,
  data () {
    return {
      checkedGoods: [],
      goods: [],
      allChecked: false,
      flag: true,
      isEdit: 0
    };
  },
  computed: {
    //引入vuex状态值
    ...mapState({
      bookMark: state => state.bookMark
    })
  },
  watch: {
    //监听单选框，选择状态
    checkedGoods (e, old) {
      console.log(e)
      if (this.goods.length == e.length) {
        this.allChecked = true
      }
      else {
        this.allChecked = false
      }
    }
  },
  mounted () {
    debugger
    this.$store.state.bookMark = this.unique(this.$store.state.bookMark);
    this.goods = this.$store.state.bookMark;
    console.log(this.selectGoods);
    console.log(this.goods);
  },
  computed: {
    submitBarText () {
      const count = this.checkedGoods.length;
      return '结算' + (count ? `(${count})` : '');
    },
    totalPrice () {
      //有出现则累加，没有则为0
      return this.goods.reduce((total, item) => total + (this.checkedGoods.indexOf(item.kid) !== -1 ? parseInt(item.price * 100) * item.count : 0), 0);
    },
    ...mapState({
      selectGoods: state => state.selectGoods//绑定store.selectGoods到组件，之后可用this.selectGoods获取
    })
  },
  methods: {
    toProductDetail (itemId) {
      this.$router.push({ name: 'detail', params: { id: itemId } });
    },
    //全选返选
    checkall () {
      let arr = []
      if (this.allChecked) {
        this.goods.forEach((item, index) => {
          arr.push(this.goods[index].id)
        });
        this.checkedGoods = arr
      } else {
        this.checkedGoods = []
      }
      console.log(this.goods);
    },
    //返回上一页
    onClickLeft () {
      this.$router.go(-1);
    },
    //选中删除
    onDelete () {
      Dialog.confirm({
        title: '删除收藏夹',
        message: '确定删除选中的项？'
      }).then(() => {
        this.goods.forEach((item, index) => {
          for (var i = 0; i < this.checkedGoods.length; i++) {
            if (this.checkedGoods[i] == this.goods[index].id) {
              //过滤收藏夹的东西，删除选中的
              this.goods = this.goods.filter(item => {
                return item.id != this.checkedGoods[i]
              })
              this.$store.state.bookMark = this.goods;//改变vuex
              this.$store.state.bookMark[index].isMark = 0;
            }
          }
        });
      }).catch(() => {
        return;
      });

      // console.log(this.goods)
      // this.$router.push({ name: '/pay', params: { list: payGoods } });
    },
    //展示编辑
    edit () {

    },
    unique (arr) {
      let hashTable = {};
      let newArr = [];
      for (let i = 0, l = arr.length; i < l; i++) {
        if (!hashTable[arr[i].id]) {
          hashTable[arr[i].id] = true;
          newArr.push(arr[i]);
        }
      }
      return newArr;
    }
  }

};
</script>




// WEBPACK FOOTER //
// src/pages/bookmark/bookmark.vue